document.querySelectorAll('collection-tabs').forEach((section) => {
  const tooltipEl = section.querySelector('.tooltip-element');
  if (!tooltipEl || section.dataset.tooltipReady) return;
  section.dataset.tooltipReady = 'true';

  const observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    observer.disconnect();
    if (!window.matchMedia('(hover: hover)').matches) return;

    section.querySelectorAll('.collection-tab__products a').forEach((el) => {
      el.addEventListener('mousemove', (e) => {
        tooltipEl.innerHTML = e.target.dataset.title;
        tooltipEl.style.opacity = '1';
        tooltipEl.style.top = `${e.clientY - tooltipEl.offsetHeight - 5}px`;
        tooltipEl.style.left = `${e.clientX}px`;
      });

      el.addEventListener('mouseleave', () => {
        tooltipEl.style.opacity = '0';
      });
    });
  });
  observer.observe(section);
});
